
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns6472c363bb1404103bedc997b9e1c8faen from './en.yaml'
            i18n.addResourceBundle('en', '6472c363bb1404103bedc997b9e1c8fa', flattenObject(ns6472c363bb1404103bedc997b9e1c8faen), true, true);
        
        export default '6472c363bb1404103bedc997b9e1c8fa';
    